import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getCartToken } from "@faire/retailer-visitor-shared/serialized-data/getCartToken";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { QueryParameters as GetCartQueryParams } from "@faire/web-api--source/api/v2/carts/cartToken/get";
import fetchCart from "@faire/web-api--source/api/v2/carts/cartToken/get";
import { useInvalidateQuery as useInvalidateCartQuery, getQueryKey as getCartQueryKey } from "@faire/web-api--source/api/v2/carts/cartToken/get-hooks";
import { BrandCartsSortBy } from "@faire/web-api--source/faire/carts/BrandCartsSortBy";
import { ICartV2 } from "@faire/web-api--source/faire/carts/ICartV2";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
export var useBrandCartQueryParams = function() {
    return useCallback(function(param) {
        var brandToken = param.brandToken;
        return GetCartQueryParams.build({
            brand_tokens: [
                brandToken
            ],
            exclude_alcohol_disclaimer: false,
            sort_brand_carts_by: BrandCartsSortBy.UPDATED_AT,
            should_collapse_preorder_groups: true
        });
    }, []);
};
export var useBrandCart = function(brandToken) {
    var buildQueryParams = useBrandCartQueryParams();
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var queryResult = useQuery({
        queryKey: getCartQueryKey(getCartToken(), buildQueryParams({
            brandToken: brandToken
        })),
        queryFn: function() {
            var params = buildQueryParams({
                brandToken: brandToken
            });
            return fetchCart(getCartToken(), params);
        },
        refetchOnMount: false,
        placeholderData: keepPreviousData,
        enabled: isLoggedInRetailer
    });
    var data = useMemo(function() {
        var _queryResult_data_brand_carts, _queryResult_data, _queryResult_data_filter_sections, _queryResult_data1, _queryResult_data2;
        return ICartV2.build({
            brand_carts: (_queryResult_data = queryResult.data) === null || _queryResult_data === void 0 ? void 0 : (_queryResult_data_brand_carts = _queryResult_data.brand_carts) === null || _queryResult_data_brand_carts === void 0 ? void 0 : _queryResult_data_brand_carts.filter(isNotUndefined),
            filter_sections: (_queryResult_data1 = queryResult.data) === null || _queryResult_data1 === void 0 ? void 0 : (_queryResult_data_filter_sections = _queryResult_data1.filter_sections) === null || _queryResult_data_filter_sections === void 0 ? void 0 : _queryResult_data_filter_sections.filter(isNotUndefined),
            cart_stats: (_queryResult_data2 = queryResult.data) === null || _queryResult_data2 === void 0 ? void 0 : _queryResult_data2.cart_stats
        });
    }, [
        queryResult.data
    ]);
    return _object_spread_props(_object_spread({}, queryResult), {
        data: data,
        refetch: queryResult.refetch,
        isLoading: queryResult.isLoading
    });
};
export var useInvalidateBrandCart = function() {
    var buildQueryParams = useBrandCartQueryParams();
    var invalidateCartQuery = useInvalidateCartQuery();
    var invalidateCartRequest = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var brandToken, args;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        brandToken = param.brandToken;
                        args = [
                            getCartToken(),
                            buildQueryParams({
                                brandToken: brandToken
                            }),
                            undefined,
                            {
                                refetchType: "all"
                            }
                        ];
                        return [
                            4,
                            Promise.all([
                                invalidateCartQuery.apply(void 0, _to_consumable_array(args))
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        buildQueryParams,
        invalidateCartQuery
    ]);
    var invalidateBrandCart = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var brandToken, promises;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        brandToken = param.brandToken;
                        promises = [];
                        promises.push(invalidateCartRequest({
                            brandToken: brandToken
                        }));
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        invalidateCartRequest
    ]);
    return {
        invalidateBrandCart: invalidateBrandCart
    };
};
